import sanarAnalytics from './sanarAnalytics'
import { Monitoring, Span } from '@sanardigital/monitoring-wrapper'

const span = Span.create()

export const initializeTrackers = () => {
    try {
        Monitoring.init(`pos-checkout-web-${window.env.ENVIRONMENT}`)
        Monitoring.initWebVitals()
    } catch (error) {
        span.emit({
            message: 'Error initializing trackers',
            type: 'ERROR',
            attributes: error,
        })
    }

    sanarAnalytics.init()
}
